import React from 'react';

const Terms = () => {
  const lastUpdated = "March 16, 2026";
  const supportEmail = "support@hashhouseyoga.com";

  return (
    <div className="max-w-4xl mx-auto px-6 py-12 text-gray-800 leading-relaxed">
      <h1 className="text-3xl font-bold mb-4">Terms of Service</h1>
      <p className="text-sm text-gray-500 mb-8">Last Updated: {lastUpdated}</p>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">1. Acceptance of Terms</h2>
        <p>
          By accessing or using <strong>Hash House Yoga</strong> (the "Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Service.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">2. User Accounts & Authentication</h2>
        <p className="mb-4">
          Our service utilizes Google OAuth for user authentication. By logging in via Google, you agree to:
        </p>
        <ul className="list-disc ml-6 space-y-2">
          <li>Maintain the security of your Google account credentials.</li>
          <li>Provide accurate and current information if prompted.</li>
          <li>Accept responsibility for all activities that occur under your account.</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">3. Use of Service</h2>
        <p>
          You agree to use Hash House Yoga only for lawful purposes. You are prohibited from:
        </p>
        <ul className="list-disc ml-6 mt-2 space-y-1">
          <li>Attempting to interfere with the proper working of the Service.</li>
          <li>Engaging in any automated use of the system (scripts, crawlers, etc.).</li>
          <li>Reverse-engineering or attempting to extract the source code of the application.</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">4. Intellectual Property</h2>
        <p>
          The content, features, and functionality of Hash House Yoga are the exclusive property of Hash House Yoga and its licensors.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-3">5. Limitation of Liability</h2>
        <p>
          The Service is provided on an "AS IS" and "AS AVAILABLE" basis. Hash House Yoga shall not be liable for any indirect, incidental, or consequential damages resulting from your use of the Service.
        </p>
      </section>

      <section className="mb-8 border-t pt-8">
        <h2 className="text-xl font-semibold mb-3">6. Changes to Terms</h2>
        <p>
          We reserve the right to modify these terms at any time. We will notify users of any significant changes by posting the new terms on this page.
        </p>
      </section>

      <footer className="mt-12 text-sm text-gray-600">
        <p>If you have questions about these Terms, please contact us at: 
          <a href={`mailto:${supportEmail}`} className="text-blue-600 ml-1 font-medium">{supportEmail}</a>
        </p>
      </footer>
    </div>
  );
};

export default Terms;
